import { CountUp } from "countup.js";

export default CountUp;